import RichTableHeader from '@core/classes/RichTableHeader';

export class RichTableServerSide {
	refresh: () => Promise<void>;
	pageNumber: number = 1;
	pageSize: number = 25;
	autoFilters: any[] = [];
	headers: any[] | RichTableHeader[] = [];
	results: any[] = [];
	sortBy: string = null;
	asc: boolean = false;
	searchBy: string = null;
	searchText: string = null;
	additionalObject: object = {};
	total: number = 0;
	searchAfter: ES_SearchAfter = null;

	constructor(partial?: Partial<RichTableServerSide> | any) {
		if (!partial) return;

		this.refresh = partial.refresh;
		this.pageNumber = partial.pageNumber ?? 1;
		this.pageSize = partial.pageSize ?? 25;
		this.autoFilters = partial.autoFilters ?? [];
		this.headers = partial.headers?.map((h: any) => new RichTableHeader(h)) ?? [];
		this.results = partial.results ?? [];
		this.sortBy = partial.sortBy;
		this.asc = partial.asc ?? false;
		this.searchBy = partial.searchBy;
		this.searchText = partial.searchText;
		this.additionalObject = partial.additionalObject ?? {};
		this.total = partial.total ?? 0;

		if (partial.searchAfter) this.searchAfter = new ES_SearchAfter(partial.searchAfter);
	}
}

export class ES_SearchAfter {
	pageNumber: number = -1;
	searchAfter: any[] = null;

	constructor(init: ES_SearchAfter) {
		this.pageNumber = init.pageNumber ?? -1;
		this.searchAfter = init.searchAfter;
	}
}
